let timeout: NodeJS.Timeout;
export default function debounce(callback: () => void, ms: number = 1000) {
  clearTimeout(timeout);
  timeout = setTimeout(callback, ms);
}
